import React, { createContext, useEffect, useState, useContext } from 'react';
import requests from '../utils/requests';
import { PersonContext } from './Person';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';

export const VendorContext = createContext();

const Vendor = ({ children }) => {
    const { authorizing, auth, app } = useContext(PersonContext);

    const [vendors, setVendors] = useState([]);
    const [vendor, setVendor] = useState({});

    useEffect(() => {
        if (authorizing) return;
        requests.getMyVendor(auth).then(({ vendor, vendors }) => {
            setVendors(vendors);
            setVendor(vendor);
        });
    }, [authorizing]);

    const refreshVendor = (id) => {
        requests.getMyVendor(auth, id || vendor.id || null).then(({ vendor, vendors }) => {
            setVendors(vendors);
            setVendor(vendor);
        });
    }

    const refreshItems = (id) => {
        requests.getMyVendor(auth, id || vendor.id || null).then(({ vendor, vendors }) => {
            setVendors(vendors);
            setVendor(vendor);
        });
    }

    const [filters, setFilters] = useState({
        fromDate: new Intl.DateTimeFormat('en-CA', { timeZone: "America/New_York", year: 'numeric', month: '2-digit', day: '2-digit', }).format(new Date()),
        toDate: "",
    });

    const [orders, setOrders] = useState([]);
    const [gettingOrders, setGettingOrders] = useState(true);
    const refreshOrders = (load) => {
        if (!vendor.id) return;
        if (load) setGettingOrders(true);
        requests.getMyVendorOrders(auth, filters, vendor.id).then(orders => {
            setOrders(orders);
        });
        setGettingOrders(false);
    }
    useEffect(() => {
        refreshOrders();
    }, [vendor, filters]);

    const [newNotifications, setNewNotifications] = useState(false);
    const [silentNotifications, setSilentNotifications] = useState(false);
    const [snapVendorId, setSnapVendorId] = useState(null);
    const db = getFirestore(app);
    useEffect(() => {
        if (authorizing || !db || !vendor.id) return;
        setSnapVendorId(vendor.id);
        const unsubscribe = onSnapshot(collection(db, "vendors", vendor.id, "notifications"), (snapshot) => {
            snapshot.docChanges().forEach(change => {
                if (change.type === "added") {
                    console.log("New Notification", change.doc.data());
                    requests.deleteVendorNotification(auth, change.doc.id, vendor.id);
                    if (!change.doc.data().silent) {
                        setNewNotifications(true);
                    } else {
                        setSilentNotifications(true);
                    }
                }
            });
        });
        return () => unsubscribe();
    }, [vendor, authorizing]);

    useEffect(() => {
        if (authorizing || !vendor) return;
        console.log("normal Refreshing vendor");
        refreshOrders(true);
        if (newNotifications) {
            setNewNotifications(false);
        }
    }, [authorizing, newNotifications]);

    useEffect(() => {
        if (authorizing || !vendor) return;
        console.log("silent Refreshing vendor");
        refreshOrders();
        setSilentNotifications(false);
    }, [silentNotifications]);

    return (
        <VendorContext.Provider value={{
            orders, gettingOrders, setOrders, refreshOrders, filters, setFilters, setGettingOrders,
            vendors, setVendor, silentNotifications, newNotifications, vendor, refreshVendor, refreshItems
        }}>
            {children}
        </VendorContext.Provider>
    );
}
export default Vendor;